/**
 * AndVLine - 折线图组件
 * 基于 Ant Design Charts Line
 */
import React from 'react';
import { Line } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVLineProps } from '../base/types';

// 默认示例数据（设计器中展示）
const DEFAULT_LINE_DATA = [
  { year: '2020', value: 3 },
  { year: '2021', value: 4 },
  { year: '2022', value: 3.5 },
  { year: '2023', value: 5 },
  { year: '2024', value: 4.9 },
  { year: '2025', value: 6 },
];

// 使用 HOC 包装基础 Line 组件
const LineWithBase = withBaseChart<AndVLineProps>(Line, {
  chartType: 'AndVLine',
  defaultHeight: 300,
  defaultData: DEFAULT_LINE_DATA,
});

/**
 * AndVLine 折线图组件
 * 用于展示数据的连续变化趋势，适用于时间序列分析、数据对比等场景
 */
export const AndVLine: React.FC<AndVLineProps> = (props) => {
  const {
    xField = 'year',
    yField = 'value',
    seriesField,
    smooth = false,
    connectNulls = false,
    lineStyle,
    ...baseProps
  } = props;

  return (
    <LineWithBase
      {...baseProps}
      xField={xField}
      yField={yField}
      seriesField={seriesField}
      smooth={smooth}
      connectNulls={connectNulls}
      lineStyle={lineStyle}
    />
  );
};

export type { AndVLineProps };
export default AndVLine;
